import React from 'react';

import { Button } from 'react-bootstrap5';

import { useContext } from '../Context';

export default function Welcome() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: true,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <div className="bg-photo bg-members-onboarding-welcome-photo" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
            <h1>Welcome!</h1>
            <p className="mt-3">
              Your Talent Insurance program is about one thing,
              and one thing only - Unlocking Your Full Potential!
            </p>
            <p>
              Over the next few minutes you’ll complete the onboarding process for your
              Talent Insurance program in five easy steps.
            </p>
            <p className="fw-semibold">
              Step 1: Complete Your Talent Assessment
            </p>
            <p className="fw-semibold">
              Step 2: Build Your Development Program
            </p>
            <p className="fw-semibold">
              Step 3: Take Your Learning Style Assessment
            </p>
            <p className="fw-semibold">
              Step 4: Select Your Coach
            </p>
            <p className="fw-semibold">
              Step 5: Schedule Your Coaching Sessions
            </p>
            <p>
              We are excited to have you onboard and are here to help guide you
              through your professional development journey!
            </p>
            <div className="mt-auto">
              <Button
                onClick={onGoNextClick}
                className="d-block d-sm-inline-block mt-4 mt-sm-3"
              >
                Let&apos;s Go!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
